import type { MRT_ColumnFiltersState, MRT_SortingState } from "mantine-react-table";
import { useCallback, useMemo } from "react";
import type { ChatVectorIndexShorthand } from "src/db";
import { useDatasources } from "src/hooks/useDatasources";
import { useSearchAfterPagination } from "src/hooks/useSearchAfterPagination";

interface UseMetadataDocumentsQueryParams {
    index: ChatVectorIndexShorthand;
    sorting: MRT_SortingState;
    columnFilters: MRT_ColumnFiltersState;
    globalFilter?: string;
}

export const useMetadataDocumentsQuery = ({
    index,
    sorting,
    columnFilters,
    globalFilter,
}: UseMetadataDocumentsQueryParams) => {
    const buildPayload = useCallback(() => {
        return (
            columnFilters
                ?.filter((val) =>
                    Array.isArray(val.value)
                        ? val.value.filter(Boolean).length > 0
                        : Boolean(val.value),
                )
                .map((filter) => {
                    const key = filter.id.split("__")[1] ?? filter.id;
                    return {
                        key,
                        value: filter.value,
                    };
                }) ?? []
        );
    }, [columnFilters]);
    const { data: chatVectorIndex = [] } = useDatasources();

    const indexValue = useMemo(
        () => chatVectorIndex?.find((ind) => ind.shorthand === index)?.value || "",
        [index, chatVectorIndex],
    );
    return useSearchAfterPagination({
        queryKey: ["metadata-documents", index, sorting, columnFilters, globalFilter],
        index: indexValue,
        sorting,
        columnFilters,
        globalFilter,
        buildPayload,
        resetDependencies: [index],
    });
};
